import { faXmark } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { capitalize } from 'lodash';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { closeOverlay } from '../../actions/overlay';
import { animationDelay } from '../../constants/styles';
import { isAlgarDeskSelector, isBtoBSelector, projectSelector, selectedProjectSelector } from '../../selectors';
import { formatDate } from '../../utils/date';
import OverlayCentered from '../overlay-centered';
import { getProjectStatus } from '../page-project-list/helpers';
import { ProjectStatus } from '../page-project-list/styled';
import { closeAnimationName, GotToFolderBtn, openAnimationName, ProjectAdditionalInfoBody, ProjectAdditionalInfoBodyLine, ProjectAdditionalInfoBtnClose, ProjectAdditionalInfoFooter, ProjectAdditionalInfoHeader, ProjectAdditionalInfoStyled, StyledProjectStatusDesk } from './styled';
const ProjectAdditionalInfoOverlay = () => {
  const dispatch = useDispatch();
  const [animation, setAnimation] = React.useState(openAnimationName);
  const isBtoB = useSelector(isBtoBSelector);
  const isDesk = useSelector(isAlgarDeskSelector);
  const project = useSelector(selectedProjectSelector);
  let {
    workTypes
  } = useSelector(projectSelector);
  workTypes = Object.values(workTypes);
  const workTypeNames = workTypes.filter(wt => project.workTypesIds.includes(wt.id)).map(wt => capitalize(wt.name));
  const projectName = project.name || project.projectname || project.dealname;
  const projectStatus = getProjectStatus(project.dealstage, isBtoB, isDesk, project.pipeline, project.flowType);
  const isTypeDesk = project.typeClient.toLowerCase() === 'desk';
  const datas = [{
    id: 1,
    label: 'Nom du dossier',
    value: projectName
  }, {
    id: 2,
    label: 'Type',
    value: isDesk ? 'Création du dossier, dépôt & gestion administrative' : '-'
  }, {
    id: 3,
    label: 'Statut',
    value: projectStatus.title
  }, {
    id: 4,
    label: 'Types de projets',
    value: workTypeNames.join(', ')
  }, {
    id: 5,
    label: 'Adresse',
    value: project.address
  }, {
    id: 6,
    label: 'Créé le',
    value: formatDate(project.createdAt)
  }, {
    id: 7,
    label: 'Déposé le',
    value: formatDate(project.dateExpedition)
  }, {
    id: 8,
    label: "Début d'instruction",
    value: formatDate(project.dateDepotMontage)
  }, {
    id: 9,
    label: "Numéro de dossier",
    value: project.numeroInstruction
  }, {
    id: 10,
    label: "Fin d'instruction estimée",
    value: formatDate(project.dateFinInstruction)
  }, {
    id: 11,
    label: "Réception d'une DPC",
    value: formatDate(project.dateReceptionDpc)
  }, {
    id: 12,
    label: 'Dépôt des pièces complémentaires',
    value: formatDate(project.dateDepotPc)
  }, {
    id: 13,
    label: 'Décision',
    value: formatDate(project.dateDecision)
  }];
  const handleClose = e => {
    e.stopPropagation();
    setAnimation(closeAnimationName);
    setTimeout(() => {
      dispatch(closeOverlay());
    }, animationDelay * 1000);
  };
  const handleAccessToFolder = () => {
    window.location.href = `/projet/${project.id}`;
  };
  return /*#__PURE__*/React.createElement(OverlayCentered, {
    isFullScreen: true,
    withCloseButton: false,
    noPadding: true,
    isTransparent: true
  }, /*#__PURE__*/React.createElement(ProjectAdditionalInfoStyled, {
    animation: animation
  }, /*#__PURE__*/React.createElement(ProjectAdditionalInfoHeader, null, /*#__PURE__*/React.createElement(ProjectAdditionalInfoBtnClose, {
    onClick: handleClose
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faXmark,
    size: "2x"
  }))), /*#__PURE__*/React.createElement(ProjectAdditionalInfoBody, null, datas.map(_ref => {
    let {
      id,
      label,
      value
    } = _ref;
    return /*#__PURE__*/React.createElement(ProjectAdditionalInfoBodyLine, {
      key: `project-data-${id}`
    }, /*#__PURE__*/React.createElement("span", null, label), id === 2 ? /*#__PURE__*/React.createElement(React.Fragment, null, isTypeDesk ? /*#__PURE__*/React.createElement(StyledProjectStatusDesk, {
      statusColor: projectStatus.color
    }, "SILVER") : /*#__PURE__*/React.createElement("span", null, value)) : id === 3 ? /*#__PURE__*/React.createElement(ProjectStatus, {
      statusColor: projectStatus.color
    }, projectStatus.title) : /*#__PURE__*/React.createElement("span", null, value));
  })), /*#__PURE__*/React.createElement(ProjectAdditionalInfoFooter, null, /*#__PURE__*/React.createElement(GotToFolderBtn, {
    onClick: handleAccessToFolder
  }, "Acc\xE9der au dossier"))));
};
export default ProjectAdditionalInfoOverlay;